import clsx from 'clsx'
import { useRouter } from 'next/router'

import CartDrawer from '../../../checkout/components/CartDrawer'
import useCartDrawerOpen from '../../../checkout/hooks/useCartDrawerOpen'
import CartRail from '../../../checkout/components/cartRail/CartRail'
import useCartRailVisible from '../../../checkout/hooks/useCartRailVisible'
import { AppRoutes } from '../../../app/constants'

import MainFooter from './footer/MainFooter'
import MainNavbar from './navBar/MainNavbar'
import MobileSideDrawer from './navBar/MobileSideDrawer'
import styles from './MainLayout.module.scss'

function MainLayout({ children }: React.PropsWithChildren) {
  const isCartDrawerVisible = useCartDrawerOpen()
  const isCartRailVisible = useCartRailVisible()
  const { pathname } = useRouter()

  // Start page: the page and the footer fit one screen together
  const isOneScreen = pathname === AppRoutes.Home

  const page = (
    <>
      <div
        className={clsx(styles.content, {
          [styles.drawerOpen]: isCartDrawerVisible,
          [styles.railVisible]: isCartRailVisible,
        })}
      >
        {children}
      </div>
      <MainFooter />
    </>
  )

  return (
    <>
      <MainNavbar />
      {isOneScreen ? <div className={styles.oneScreen}>{page}</div> : page}
      <CartDrawer />
      <CartRail />
      <MobileSideDrawer />
    </>
  )
}

export default MainLayout
